import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { LeaveListState } from "@reducers/types/HRM/leave-list-state";

import { getLeaveListRequest } from "@actions/HRM/leave/leave-list-actions";
import { getLeaveListState } from "@selectors/HRM/leave/leave-list-selectors";

import { useAppSelector } from "@helpers/redux";

import { LeaveListResponseType, LeaveType } from "@type/HRM/leaves";
import { PaginationRequestType, PaginationType } from "@type/HRM/pagination";

interface UseLeaveList {
  leaveListRequest: boolean;
  leaveListSuccess: boolean;
  leaveListFailed: boolean;
  leaveList: LeaveType[];
  pagination: PaginationType;
  handleQuery: (key: string, value: string | number | null) => void;
}

export const useLeave = (): UseLeaveList => {
  const dispatch = useDispatch();

  const [query, setQuery] = useState<PaginationRequestType>({
    page: 1,
    size: 10,
    search: "",
    status: null,
  });

  const handleQuery = (key: string, value: string | number | null) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  const getLeaveList = useAppSelector<LeaveListState>(getLeaveListState);

  const leaveListRequest = getLeaveList.request as boolean;
  const leaveListSuccess = getLeaveList.success as boolean;
  const leaveListFailed = getLeaveList.failed as boolean;
  const { data: leaveList, pagination } = getLeaveList.data
    ? getLeaveList.data
    : ({} as LeaveListResponseType);

  useEffect(() => {
    dispatch(getLeaveListRequest(query));
  }, [dispatch, query]);

  return {
    leaveListRequest,
    leaveListSuccess,
    leaveListFailed,
    leaveList,
    handleQuery,
    pagination,
  };
};
